import { gql } from '@apollo/client'

export const GET_TICKETS_RESOLVED_BY_USER = gql`
  query GetTicketsResolvedByUser(
    $searchQuery: String
    $filters: filtersTicketsResolvedByUser
  ) {
    getTicketsResolvedByUser(searchQuery: $searchQuery, filters: $filters) {
      count_status_complet
      user_name_complet
    }
  }
`

export const GET_AVERAGE_TIME_OF_CREATE_REPORT_CITIZEN = gql`
  query GetAverageTimeOfCreateReportCitizen(
    $filters: filtersAverageTimeOfAttention
  ) {
    getAverageTimeOfCreateReportCitizen(filters: $filters) {
      day
      time
    }
  }
`

export const GET_AVERAGE_TIME_OF_ATTENTION = gql`
  query GetAverageTimeOfAttention($filters: filtersAverageTimeOfAttention) {
    getAverageTimeOfAttention(filters: $filters) {
      day
      time
    }
  }
`

export const GET_AVERAGE_TIME_BY_STATUS_ID = gql`
  query GetAverageTimeByStatusChange(
    $startStatusId: Int!
    $endStatusId: Int!
    $filters: filtersAverageTimeByStatusChange
  ) {
    result: getAverageTimeByStatusChange(
      start_status_id: $startStatusId
      end_status_id: $endStatusId
      filters: $filters
    ) {
      day
      time
    }
  }
`

export const GET_COUNT_ALL_TICKETS = gql`
  query ($statusId: Int, $filters: filtersCountTicketsByStatus) {
    result: getCountAllTickets(status_id: $statusId, filters: $filters)
  }
`
